import { URLASSOLUTO, URLASSOLUTOISTITUZIONALE, URLRICERCA } from "./variables";
import Swal from "./sweetalert2";
import bootstrapvalidation from "./validate";

//import './jquery.flexdatalist'; // messo script localmente perchè non funziona da node_modules...
$("html").addClass("is-loading");

$(document).ready(function () {

    $("body").on("click", "#ricercalibera", function () {
        $.ajax({
            url: `${URLASSOLUTO}/get-ricerca?action=divisioni`,
            method: "GET",
            dataType: "json"
        }).done(function (divisioni) {
            let divisionOptions = '<select name="divisione" id="divisione" class="form-select mb-3"><option value="">Seleziona divisione</option>';
            divisioni.forEach(divisione => {
                divisionOptions += `<option data-prodottic="${divisione.prodottic}" data-applicazionic="${divisione.applicazionic}" value="${divisione.id}">${divisione.nome}</option>`;
            });
            divisionOptions += '</select>';

            // Aggiungi la tendina fissa per tipologia (inizialmente disabilitata)
            const tipologiaSelect = `
                <select name="tipologia" id="tipologia" class="form-select mb-3" disabled>
                    <option value="">Seleziona tipologia</option>
                    <option value="prodotto">Prodotto</option>
                    <option value="applicazione">Applicazione</option>
                </select>
            `;

            // Aggiungi la tendina per prodotti/applicazioni (inizialmente disabilitata)
            const prodottoSelect = `<select name="prodotto" id="prodotto" class="form-select mb-3" disabled><option value="">Seleziona prodotto/applicazione</option></select>`;
            // Ottenere il token CSRF dal meta tag
            const csrfToken = $('meta[name="csrf-token"]').attr('content');
            // HTML per il contenuto della SweetAlert
            const htmlContent = `
                <div class="p-4" style="background-color: white; border-radius: 10px; max-width: 500px; margin: auto;">
                    <h5 class="text-center mb-4" style="font-weight: bold;">Ricerca Veloce</h5>
                    <form action="${URLASSOLUTO}/${URLRICERCA}" method="post" id="formSearch" class="formSearch position-relative" novalidate accept-charset="utf-8" >
                        <input type="hidden" name="_token" value="${csrfToken}"> <!-- Token CSRF -->
                        ${divisionOptions}
                        ${tipologiaSelect}
                        ${prodottoSelect}
                        <span id="btnCerca" class="btn btn-success w-100">Cerca</span>
                    </form>
                </div>
            `;

            // Mostra il SweetAlert
            Swal.fire({
                background: "rgba(0, 0, 0, 0.7)", // Background semitrasparente
                position: "center",
                grow: "fullscreen",
                showCloseButton: true,
                showConfirmButton: false,
                customClass: {
                    container: "filtri-fullscreen"
                },
                html: htmlContent,
                onOpen: () => {
                    initFilterListeners(); // Inizializza i listener quando il dialogo è aperto
                }
            });
        });
    });

    function initFilterListeners() {

        // Listener per il click sullo span "Cerca"
        $("body").on('click', '#btnCerca', function (event) {
            event.preventDefault();
            event.stopPropagation();

            // Recupera il valore della select "divisione"
            const divisioneId = $("#divisione").val();

            // Controlla se la divisione è stata selezionata
            if (!divisioneId) {
                // Se non è selezionata, mostra un messaggio di errore
                $("#divisione").addClass('is-invalid'); // Aggiunge la classe di errore Bootstrap
                if ($("#divisione").next('.invalid-feedback').length === 0) {
                    // Se il messaggio di errore non esiste già, lo aggiunge
                    $("#divisione").after('<div class="invalid-feedback">Seleziona una divisione.</div>');
                }
            } else {
                // Se la divisione è selezionata, rimuove eventuali errori e invia il form
                $("#divisione").removeClass('is-invalid'); // Rimuove la classe di errore
                $("#divisione").addClass('is-valid'); // Aggiunge la classe di successo
                console.log('invia');
                // Invia il form
                $(this).closest('form').submit();
            }
        });

        // Listener per la selezione della divisione
        $("body").on("change", "#divisione", function () {
            const divisioneId = $(this).val();


            const prodottic = $('#divisione  option:selected').data('prodottic');
            const applicazionic = $('#divisione  option:selected').data('applicazionic');

            // Aggiungi la tendina fissa per tipologia (inizialmente disabilitata)
            const tipologiaSelect = `
                <select name="tipologia" id="tipologia" class="form-select mb-3" disabled>
                    <option value="">Seleziona tipologia</option>
                    <option value="prodotto">Prodotto</option>
                    <option value="applicazione">Applicazione</option>
                </select>
            `;

            // Aggiungi la tendina fissa per tipologia (inizialmente disabilitata)
            const tipologiaSelectP = `
                <select name="tipologia" id="tipologia" class="form-select mb-3" disabled>
                    <option value="">Seleziona tipologia</option>
                    <option selected value="prodotto">Prodotto</option>
                </select>
            `;

            // Aggiungi la tendina fissa per tipologia (inizialmente disabilitata)
            const tipologiaSelectA = `
                <select name="tipologia" id="tipologia" class="form-select mb-3" disabled>
                    <option value="">Seleziona tipologia</option>
                    <option selected value="applicazione">Applicazione</option>
                </select>
            `;

            // Abilita la tendina per la tipologia solo se una divisione è selezionata
            if (divisioneId) {
                $(this).removeClass('is-invalid'); // Rimuove la classe di errore
                $(this).next('.invalid-feedback').remove(); // Rimuove il messaggio di errore
                if (prodottic == 0 && applicazionic > 0) {
                    $("#tipologia").html(tipologiaSelectA).prop("disabled", false).trigger('change'); // Abilita la tendina per la tipologia
                } else if (prodottic > 0 && applicazionic == 0) {
                    $("#tipologia").html(tipologiaSelectP).prop("disabled", false).trigger('change'); // Abilita la tendina per la tipologia
                } else {
                    $("#tipologia").html(tipologiaSelect).prop("disabled", false); // Abilita la tendina per la tipologia
                }

            } else {
                // Disabilita la tendina per la tipologia e i prodotti/applicazioni
                $("#tipologia").html(tipologiaSelectA).prop("disabled", true).val(""); // Resetta il valore della tipologia
                $("#prodotto").html('<option value="">Seleziona prodotto/applicazione</option>').prop("disabled", true); // Disabilita la tendina dei prodotti/applicazioni
            }

            // Resetta la tendina dei prodotti/applicazioni quando cambia la divisione
            $("#prodotto").html('<option value="">Seleziona prodotto/applicazione</option>').prop("disabled", true); // Disabilita la tendina
        });

        // Listener per la selezione della tipologia
        $("body").on("change", "#tipologia", function () {
            const divisioneId = $("#divisione").val(); // Ottieni il valore della divisione selezionata
            const tipologia = $(this).val(); // Ottieni il valore della tipologia selezionata

            if (divisioneId && tipologia) {
                // Richiesta AJAX per ottenere i prodotti o le applicazioni quando cambia la tipologia
                $.ajax({
                    url: `${URLASSOLUTO}/get-ricerca?action=prodotti`,
                    method: "GET",
                    data: {
                        divisioneId: divisioneId,
                        tipologia: tipologia // Includi la tipologia nella richiesta
                    },
                    dataType: "json"
                }).done(function (risultati) {
                    let prodottoOptions = '<option value="">Seleziona prodotto/applicazione</option>';
                    risultati.forEach(item => {
                        prodottoOptions += `<option value="${item.id}">${item.nome}</option>`;
                    });
                    $("#prodotto").html(prodottoOptions).prop("disabled", false); // Abilita la tendina
                });
            } else {
                $("#prodotto").html('<option value="">Seleziona prodotto/applicazione</option>').prop("disabled", true); // Disabilita la tendina
            }
        });

    }




    let hash = window.location.hash;
    if ($(hash + "L").length) {
        $("html, body").animate(
            {
                scrollTop: $(hash + "L").offset().top,
            },
            1000
        );
    }
    if (hash === "#lavoraconnoi" && $(".bloccoformcontatti").length) {
        $("#tab2").attr("checked", true);
        $(".labellavoraconnoi").trigger("click");
        $("html, body").animate(
            {
                scrollTop: $(".bloccoformcontatti").offset().top,
            },
            1000
        );
    }

    // fade out background preloader
    $.when(
        $("#preload").fadeOut(function () {
            /*$(".immagine-header.homepage").addClass('isvisible');*/
        })
    ).done(function () {
        console.log("afterfadeout");
        $("html").removeClass("is-loading");
        $("html").addClass("is-first-loaded");
        $("html").addClass("is-loaded");
    });

    /*    $('body').on('click', '#nav-icon1,#nav-icon2,#nav-icon3,#nav-icon4', function () {
		$('.nav-icon-toggle').toggleClass('open');
        $('body').toggleClass('menuopen');
        $('.menuleft').toggleClass('open');
        $('.menuleft').find('nav').toggleClass('open');
	});
*/



    $("body").on("click", ".annopaperselector", function () {
        $(this).find('.btn-biancointoverde2').toggleClass('attivo');
        //console.log($(this), 'aaa');
        if($('.btn-biancointoverde2.attivo').length > 0) {
            /*$('.boxpaper').fadeOut();
            $('.btn-biancointoverde2.attivo').each(function (index) {
                let annoselected = $(this).parent().data("annosel");
                //console.log(annoselected, 'bbb');
                $('.boxpaper.annopaper-' + annoselected).fadeIn();
            });
            */
            $('.btn-biancointoverde2').each(function (index) {
                let annoselected = $(this).parent().data("annosel");
                if ($(this).hasClass('attivo')) {
                    $('.boxpaper.annopaper-' + annoselected).fadeIn();
                } else {
                    $('.boxpaper.annopaper-' + annoselected).fadeOut();
                }

                //console.log(annoselected, 'bbb');

            });
        } else {
            //$('.boxpaper').removeClass('d-none');
            $('.boxpaper').fadeIn();
        }

    });


    $(".sameheight").css("height", "auto");
    $(".sameheight").boxheight();
    $(".dooverflown").boxoverflown();
    $("body").on("change", ".languageselector", function () {
        var languageselected = $(this).find(":selected").data("path");
        if (typeof languageselected !== "undefined") {
            window.location.href = languageselected;
        }
    });
    $("body").on("change", ".applicationgroupselecter", function () {
        var applicationgroupselecter = $(this).find(":selected").data("path");
        if (typeof applicationgroupselecter !== "undefined") {
            window.location.href = applicationgroupselecter;
        }
    });
    $("body").on("click", ".calltoactionwwu", function () {
        $("#tab2").attr("checked", true);
        $(".labellavoraconnoi").trigger("click");
        $("html, body").animate(
            {
                scrollTop: $(".bloccoformcontatti").offset().top,
            },
            1000
        );
    });

    $("body").on("keydown", ".ricercainput", function (event) {
        if (event.keyCode === 13) {
            console.log('doricerca');
            // Add your code here
            $(this).closest('form').find('button').trigger('click');
        }
    });
    $("body").on("click", ".doricerca", function (event) {
        console.log('doricerca');
        $(this).closest('form').find('button').trigger('click');
    });


});

$(window).resize(function () {
    $(".sameheight").css("height", "auto");
    $(".sameheight").boxheight();
    $(".dooverflown").boxoverflown();
});
